import { Configuration } from "@azure/msal-browser";
import { APP_REDIRECT_URL, GRAPH_API_BASE_URL } from './config/env';

const AppClientId = import.meta.env.VITE_AZURE_ACTIVE_DIRECTORY_APP_CLIENT_ID as string | undefined;
const AzureTenantId = import.meta.env.VITE_AZURE_ACTIVE_DIRECTORY_APP_TENANT_ID as string | undefined;

const productRedirectUrl = APP_REDIRECT_URL;

export const msalConfig: Configuration = {
    auth: {
        clientId: AppClientId || '',
        authority: `https://login.microsoftonline.com/${AzureTenantId}`,
        redirectUri: productRedirectUrl,
        // postLogoutRedirectUri: "/"
    },
    cache: {
		cacheLocation: 'sessionStorage',
		storeAuthStateInCookie: true,
	},
};

export const loginRequest = {
    scopes: ["api://51344919-c710-4f0d-b863-25f5020d89dd/access_as_user"]
};

export const graphConfig = {
    graphMeEndpoint: `${GRAPH_API_BASE_URL}/v1.0/me`
};